import { render } from "./globalModal.vue?vue&type=template&id=00214f60&scoped=true"
import script from "./globalModal.vue?vue&type=script&lang=js"
export * from "./globalModal.vue?vue&type=script&lang=js"

import "./globalModal.vue?vue&type=style&index=0&id=00214f60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00214f60"]])

export default __exports__